import { Stack, Typography } from "@mui/material"
import React, { useMemo } from "react"
import StepPaymentItem from "./StepPaymentItem/StepPaymentItem"
import { UseFormWatch } from "react-hook-form"
import { TSale } from "../../../../../core/types/Sale"
import NumberFunctions from "../../../../../core/functions/NumberFunctions"
import { useCheckoutContext } from "../../../../../core/hooks/useCheckoutContext"
import { useTranslation } from "react-i18next"

interface BoletoPaymentPrice7Props {
  visible: boolean
  index: number
  watch: UseFormWatch<TSale>
}

const BoletoPaymentPrice7 = ({
  visible,
  index,
  watch,
}: BoletoPaymentPrice7Props) => {
  const { displayCurrency } = useCheckoutContext()
  const { t } = useTranslation()
  const values = useMemo(
    () => ({
      paymentPixValue: watch(`payment.payments.${index}.value`),
      paymentTotal: watch("payment.total"),
    }),
    [watch(`payment.payments.${index}.value`), watch("payment.total")]
  )

  return (
    <Stack spacing={1}>
      <Stack
        direction="column"
        spacing={1}
        sx={{ display: visible ? undefined : "none" }}
      >
        <Typography
          color="#464A5A"
          fontSize="16px"
          lineHeight="16px"
          fontWeight={500}
        >
          {t("checkout.v7.boleto.intro")}
        </Typography>

        <Typography
          color="#464A5A"
          fontSize="16px"
          lineHeight="16px"
          fontWeight={500}
        >
          <ul>
            <li>
              {t("checkout.v7.pix.cashValue")}{" "}
              <b style={{ fontSize: "20px" }}>
                {NumberFunctions.formatMoneyCurrency(values.paymentTotal, displayCurrency)}
              </b>
            </li>
            <li>
              {t("checkout.v7.pix.noInstallments")}
            </li>
            <li>
              {t("checkout.v7.boleto.clearingTime")}
            </li>
          </ul>
        </Typography>
      </Stack>
    </Stack>
  )
}

export default BoletoPaymentPrice7
